<span class="estampa" [class.estampa-con-nombre]="conNombre">
  <span class="estampa-av" [ngClass]="'estampa-' + tam" [attr.title]="conNombre ? null : titulo" [attr.aria-label]="conNombre ? null : titulo"
        [style.background]="e?.logoUrl && !logoFallo ? '#FFFFFF' : e?.color" [style.color]="e?.letra">
    <img *ngIf="e?.logoUrl && !logoFallo; else letras" [src]="e?.logoUrl" alt="" loading="lazy" (error)="logoFallo = true">
    <ng-template #letras>{{ e?.iniciales || '' }}</ng-template>
  </span>
  <span class="estampa-texto" *ngIf="conNombre">
    <span class="estampa-nombre">{{ e?.nombre || nombre || codigo || 'MT' }}</span>
    <span class="estampa-sub">{{ e?.code || codigo || 'MT' }}<ng-container *ngIf="sub"> · {{ sub }}</ng-container></span>
  </span>
</span>
